<template>
  <div class="flex flex-col" ref="sectionRef">
    <ElementMap :blok="blok" :theme="theme" :markerColor="markerColor" />
  </div>
</template>
<script setup lang="ts">
import { TemplateMapOverviewStoryblok } from '@/types';
import useSectionTheme from '@/composables/useSectionTheme';
import { ISbPluginThemeColorPicker } from '@/types';

interface Props {
  blok: TemplateMapOverviewStoryblok;
}
const props = defineProps<Props>();

const sectionRef = ref<HTMLElement | null>(null);
const { observeThemeSection } = useSectionTheme();
const theme = computed(() => {
  const colors = props.blok.backgroundColor as ISbPluginThemeColorPicker;
  return {
    bg: colors.hex,
    text: colors.hexFg,
  };
});
const markerColor = computed(() => {
  const colors = props.blok.markerColor as ISbPluginThemeColorPicker;
  return {
    bg: colors.hex,
    text: colors.hexFg,
  };
});

observeThemeSection(sectionRef, theme);
</script>

<style scoped></style>
